module.exports = __webpack_public_path__ + "img/carltonstreetdeck-h-474x356.fff19750.jpg";